import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  clients: {},
  offlineLicenses: {},
  permanentLicenses: {},
  temporaryLicenses: {},
  trialLicenses: {},
  productReleases: {},
  productReleasesHistory: {},
  clientsHistory: {},
  offlineLicensesHistory: {},
  permanentLicensesHistory: {},
  temporaryLicensesHistory: {},
  trialLicensesHistory: {},
  history: {
    dataField: 'connectionDateTime',
    order: 'desc',
  },
  adminHistory: {
    dataField: 'eventDateTime',
    order: 'desc',
  },
  accounts: {},
  accountsHistory: {},
  wrongActivationsHistory: {},
  features: {},
  deviceFeatures: {},
  trialRejectedDevices: {},
  trialRejectedDevicesHistory: {},
  webViewerFeaturePackages: {},
  webViewerServers: {},
  webViewerServersHistory: {},
  webViewerLicenses: {},
  webViewerLicensesHistory: {},
  trialSettingsHistory: {},
  bannedDevices: {},
  banHistory: {},
};

const sortTables = createSlice({
  name: 'sortTables',
  initialState,
  reducers: {
    setOrder: (state, action) => {
      const { objectName, dataField, order } = action.payload;
      state[objectName] = { dataField, order };
    },
  },
});

const { reducer, actions } = sortTables;

const { setOrder } = actions;

export const setSortDirection = (objectName, dataField, order) => (dispatch) => {
  return new Promise((resolve) => {
    dispatch(setOrder({ objectName, dataField, order }));
    resolve();
  });
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/userConfigs/orderTablesSlice.js